import styled from "styled-components";

export const FilterContainer = styled.div`
  background: #f5f5f5;
  border-radius: 16px;
  padding: 4px;
  width: fit-content;

  ul {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    padding: 0;
    margin: 0;
    list-style: none;

    li {
      font-family: "Geist", sans-serif;
      font-weight: 400;
      font-size: 12px;
      line-height: 1.5em;
      text-align: center;
      cursor: pointer;
      padding: 4px 10px;
      border-radius: 12px;
      color: #717680;
      background: transparent;
      transition: all 0.2s ease;

      &:hover {
        background: rgba(250, 250, 250, 0.5);
      }

      &.active {
        color: #181d27;
        background: #fafafa;
      }
    }
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;
